import set from "@rill/set";
import AccountabilityTracker from "./AccountabilityTracker";
import { getAccountabilitiesTable } from "../../../../utils/daily-accountability";
import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import _ from "lodash";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const AccountabilityController = async (app) => {
  app.get(
    "/accountability",
    set("heading", "Accountability Tracker"),
    async ({ locals, res, req, load }) => {
      try {
        let {
          query,
          pathname,
          dailyStats,
          athlete,
          activeUser: coach,
          activeUserToRequest,
          activeUser,
        } = locals;
        let loadedAthlete;
        let loadedCoach;

        const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
          locals.organizationRoleName
        );

        const loadPromises = [];

        if (
          locals.activeUser.organizationId &&
          isAllowToViewAllOrganizationsAthletes &&
          !locals.allAthletesFromOrganization
        ) {
          loadPromises.push(load("allAthletesFromOrganization"));
        }

        if (athlete === undefined) {
          loadPromises.push(
            load("athlete", { user: activeUser._id }),
            load("coach", { user: activeUser.coach._id })
          );
          loadedAthlete = locals.athlete;
          loadedCoach = locals.coach;
        }

        if (locals.athlete?.customAccountability?.templateId) {
          loadPromises.push(
            load("dailyAccountabilityTemplate", {
              templateId: locals.athlete.customAccountability.templateId,
            })
          );
        }

        await Promise.all(loadPromises);
        const modal = _.get(query, "modal", {});
        locals.modal = {
          "activity-feed": <ActivityDrawer />,
        }[modal.type];
        res.body = (
          <AccountabilityTracker
            query={query}
            pathname={pathname}
            athlete={athlete || loadedAthlete}
            dailyStats={dailyStats}
            coach={athlete ? activeUserToRequest || coach : loadedCoach}
            locals={locals}
          />
        );
      } catch (e) {
        console.log(e);
      }
    }
  );
};

export default AccountabilityController;
